// extracted by mini-css-extract-plugin
export var actionText = "_qp-4";
export var container = "_qp-0";
export var leftSection = "_qp-1";
export var rightSection = "_qp-2";
export var settingsButton = "_qp-6";
export var settingsIcon = "_qp-7";
export var shortcut = "_qp-5";
export var shortcutGroup = "_qp-3";